module.exports = __webpack_public_path__ + "static/exercise-img-4-19254f5a916400803be6b717913a69e0.png";